export const uploadFileviaSignedURL = async (imageUrl, fileData) => {
  let status = false;
  try {
    var requestOptions = {
      method: "PUT",
      body: fileData.file,
    };
    const response = await fetch(imageUrl, requestOptions);
    if (response.ok) {
      status = true;
    } else {
      console.error("Upload failed", response.statusText);
    }
  } catch (error) {
    console.error("Error uploading image", error);
  }

  return status;
};
